import script from "./HandlerAccessDenied.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandlerAccessDenied.vue?vue&type=script&setup=true&lang=ts"

import "./HandlerAccessDenied.vue?vue&type=style&index=0&id=3c562e7f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c562e7f"]])

export default __exports__